import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("error-message")
export class ErrorMessage extends LitElement {
  @property() message = "Something went wrong";

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="rounded-lg border border-red-800 bg-red-950/50 p-4 text-red-300 text-sm">
        ${this.message}
      </div>
    `;
  }
}
